import useVpnStore from '@/stores/vpn';

export default function buildStationObject({ host, status, ...data }) {
  const { stationOnline } = useVpnStore();

  const parts = host.split('.');
  const number = parts.length === 4 ? `${parts[2]}` : host;
  const online = stationOnline({ host });

  return {
    key: host,

    number,
    host,
    online,
    status,

    stationName: data?.nateState?.data?.app?.station_name ?? null,
    trackName: data?.nateState?.data?.app?.track_name ?? null,

    nateRunnerApiUrl: data?.nateRunnerApiUrl,
    nateRunnerVersion: data?.nateRunnerState?.data?.app?.version,

    nateApiUrl: data?.nateApiUrl,
    nateVersion: data?.nateState?.data?.app?.nate_version,

    ...data,
  };
}
